import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  isMobileOnly
} from "react-device-detect";
import Slider from "react-slick";
import {
  getPLAYER,
} from '../../store/selectors/selectors'


import {
  togglePlay
} from '../../store/actions/index';

import {
  hideWidget
} from '../../store/actions/widget-actions';
import {
  setFrameToView,
  startedWatch,
} from '../../store/actions/play-actions';

import './style.scss';


const slickSettings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: isMobileOnly ? [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3
      }
    },
  ]

    : [
      {
        breakpoint: 499,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 399,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 360,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 320,
        settings: {
          slidesToShow: 1
        }
      },
    ]
};

class WidgetCarousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: false,
      widgetData: null,
      showBooks: false,
      showSubs: false
    };
  };

  handleReplay = () => {
    this.props.setFrameToView(0);
    this.props.startedWatch(true);
    if (this.props.viewMode !== 'text') {
      this.props.togglePlay(true);
    }
  }

  render() {

    const {
      widget: { data, isVisible },
      book,
      viewMode,
    } = this.props;

    if (!isVisible) {
      return null;
    }

    const {
      cover_h: { download_link: backgroundImage },
      bookInfo: { link_to_web }
    } = book;
    return (
      <div className="widget-end-frame">
        <div className="widget-end-frame__overlay" style={{ backgroundImage: `url(${backgroundImage})` }} />
        <button
          className="widget-end-frame__close"
          onClick={this.props.hideWidget}
        >
          close
        </button>
        <div className="widget-end-frame__body">
          <h3>Explore other stories</h3>
          {data &&
            <Slider {...slickSettings} className="widget-carousel">
              {data.channel.books.map((item, index) => (
                <a href={`${data.baseUrl}${item.slug}`} target="_blank" key={index}>
                  <img src={`${data.baseUrl}${item.cover}`} alt={item.title} />
                </a>
              ))}
            </Slider>
          }


          <div className="widget-end-frame__footer">
            <a
              href={link_to_web}
              target="_blank"
              className="widget-end-frame__link"
            >
              Visit story page
            </a>
            <a
              className="widget-end-frame__link"
              onClick={this.handleReplay}
            >
              {viewMode === 'video' ? 'Play' : ((viewMode === 'audio') ? 'Listen' : 'Watch')} again
            </a>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = ({ viewMode, loginPopup, book, app, widget, videoPlayerState }) => {
  return {
    viewMode,
    book,
    PLAYER: getPLAYER({ videoPlayerState }),
    widget
  }
};

const actionCreators = {
  startedWatch,
  hideWidget,
  setFrameToView,
  togglePlay,
};
export default connect(mapStateToProps, actionCreators)(WidgetCarousel)


// WEBPACK FOOTER //
// ./src/containers/widget-carousel/WidgetCarousel.jsx